const items = [
  { id: 't-1', label: '直播翻车', heat: '🔥 98.7万' },
  { id: 't-2', label: '人设崩塌', heat: '🔥 86.3万' },
  { id: 't-3', label: '恋情曝光', heat: '🔥 72.1万' },
  { id: 't-4', label: '平台封号', heat: '🔥 65.4万' },
  { id: 't-5', label: '虚假宣传', heat: '🔥 58.9万' },
  { id: 't-6', label: 'MCN内幕', heat: '🔥 52.3万' },
  { id: 't-7', label: '粉丝经济', heat: '🔥 47.6万' },
  { id: 't-8', label: '数据造假', heat: '🔥 41.2万' },
  { id: 't-9', label: '网红互撕', heat: '🔥 38.5万' },
  { id: 't-10', label: '合同纠纷', heat: '🔥 33.9万' },
  { id: 't-11', label: '跨界翻车', heat: '🔥 28.7万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">热门话题</h2>
          <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">全网热议</span>
        </div>

        <div className="flex flex-wrap gap-3">
          {items.map((item, i) => (
            <a
              key={item.id}
              href={`#cards`}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border transition-all cursor-pointer whitespace-nowrap ${
                i < 3
                  ? 'bg-primary-500 border-primary-500 text-background-50 hover:bg-primary-600'
                  : i < 6
                  ? 'bg-accent-100 border-accent-200 text-accent-700 hover:bg-accent-200'
                  : 'bg-secondary-100 border-secondary-200 text-foreground-700 hover:bg-secondary-200'
              }`}
            >
              <span className="text-xs md:text-sm font-medium">{item.label}</span>
              <span className={`text-xs ${i < 3 ? 'text-background-50/80' : 'text-foreground-500'}`}>{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}